import { CustomerDBStatus, CustomerDbType, CustomerLists, CustomersBySerial } from "@ip6m/types";
import { HttpException, Injectable, Logger, NotFoundException, OnApplicationBootstrap } from "@nestjs/common";
import { concat, concatMap, forkJoin, merge, NotFoundError, Observable } from 'rxjs';
import { getCustomRepository, UsingJoinTableOnlyOnOneSideAllowedError } from "typeorm";
import { CustomerDbConfigRepository } from "../../database/repositories/customer-db-config.repository";
import { CustomerDbClient, GiganetCustomerDbClient } from "./customer-db-client";

@Injectable()
export class CustomerService implements OnApplicationBootstrap {

    repo: CustomerDbConfigRepository;
    activeBackends: CustomerDBStatus[] = [];

    constructor(private defaultClient: CustomerDbClient, private giganetClient: GiganetCustomerDbClient) {}

    async onApplicationBootstrap() {
      this.repo = getCustomRepository(CustomerDbConfigRepository);
      const backends = await this.repo.getConfiguration();
      backends.forEach(backend => {
        const status = eval('this.' + backend.type + '.init()') as Observable<CustomerDBStatus>;
        status.subscribe({
          next: (value) => {
            console.log(value);
            this.activeBackends.push(value);
            Logger.log(backend.type + ' has been initialized.', this.constructor.name);
          },
          error: (err) => {
            Logger.error(err, 'CustomerDb.' + backend.type);
          }
        });
      })

      Logger.log('Started', this.constructor.name);
    }
    
    get status() {
      return this.activeBackends;
    }

    getCustomersByDb(type: CustomerDbType): Observable<CustomersBySerial> {
      if(typeof(CustomerDbType[type]) !== 'undefined') {
        return eval('this.' + CustomerDbType[type] + '.getCustomers()');
      }
      else {
        throw new NotFoundException();
      } 
    }
    
    getCustomers(sn: string = ''): Observable<CustomerLists> {
      
      const defaultDb = this.defaultClient.getCustomers(sn);
      const giganetDb = this.giganetClient.getCustomers(sn);

      let result = {};

      this.activeBackends.forEach(backend => {
        switch(backend.provider) {
          case 'default': result[backend.provider] = defaultDb; break;
          case 'giganet': result[backend.provider] = giganetDb; break;
        }
      })
      return forkJoin(result);
    }
}
